export class TaskParentDto {
    Entity: string;
    Id: number;
}